import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=6d6c6a49&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=6d6c6a49&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6c6a49",
  null
  
)

export default component.exports